import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Select, message } from 'antd';
import { SaveOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import useCompanyNavigate from '../../utils/useCompanyNavigate';
import { departmentAdminApi, departmentApi } from '../../services/api';

const DepartmentAccountForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const navigate = useCompanyNavigate();
  const { id } = useParams();
  const isEdit = !!id;

  useEffect(() => {
    fetchDepartments();
    if (isEdit) {
      fetchDetail();
    }
  }, [id]);

  const fetchDetail = async () => {
    try {
      const res = await departmentAdminApi.detail(id);
      if (res.success) {
        form.setFieldsValue({
          department_id: res.data.department_id,
          username: res.data.username,
          real_name: res.data.real_name,
          phone: res.data.phone,
          is_active: res.data.is_active,
        });
      }
    } catch (err) {
      message.error('获取账户信息失败');
    }
  };

  const fetchDepartments = async () => {
    try {
      const res = await departmentApi.all();
      setDepartments(res.data.map(d => ({ label: d.name, value: d.id })));
    } catch (err) {}
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      if (isEdit) {
        const updateData = { ...values };
        delete updateData.password; // 不传密码则不修改
        if (!values.password) delete updateData.password;
        await departmentAdminApi.update(id, updateData);
        message.success('更新成功');
      } else {
        await departmentAdminApi.create(values);
        message.success('创建成功');
        navigate('/admin/department-accounts');
      }
    } catch (err) {
      message.error(err.response?.data?.message || '操作失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24, gap: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/admin/department-accounts')}>返回</Button>
        <h2 style={{ margin: 0 }}>{isEdit ? '编辑部门账号' : '新增部门账号'}</h2>
      </div>

      <Card style={{ maxWidth: 600 }}>
        <Form form={form} layout="vertical" onFinish={onFinish} initialValues={{ is_active: 1 }}>
          <Form.Item name="department_id" label="所属部门" rules={[{ required: true, message: '请选择部门' }]}>
            <Select placeholder="请选择部门" options={departments} />
          </Form.Item>

          <Form.Item name="username" label="用户名" rules={[
            { required: true, message: '请输入用户名' },
            { min: 3, message: '用户名至少3位' }
          ]}>
            <Input placeholder="登录用户名" />
          </Form.Item>

          <Form.Item
            name="password"
            label={isEdit ? '新密码（留空不修改）' : '密码'}
            rules={isEdit ? [] : [
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6位' }
            ]}
          >
            <Input.Password placeholder={isEdit ? '留空则不修改密码' : '请输入密码'} />
          </Form.Item>

          <Form.Item name="real_name" label="真实姓名">
            <Input placeholder="请输入真实姓名" />
          </Form.Item>

          <Form.Item name="phone" label="手机号">
            <Input placeholder="请输入手机号" />
          </Form.Item>

          <Form.Item name="is_active" label="状态">
            <Select options={[
              { label: '启用', value: 1 },
              { label: '禁用', value: 0 },
            ]} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loading} style={{ background: '#8B7355' }}>
              {isEdit ? '保存修改' : '创建账号'}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default DepartmentAccountForm;
